module.exports = __webpack_public_path__ + "static/img/pat2_tr.3078e2b6.png";